import type { BoardOverview, BoardActivityItem, BoardUpdateItem } from '@hygge/shared';
import { api } from './api';

export async function getBoardOverview(boardId: string): Promise<BoardOverview> {
  const { data } = await api.get<BoardOverview>(`/boards/${boardId}/overview`);
  return data;
}

export async function getBoardActivity(boardId: string): Promise<BoardActivityItem[]> {
  const { data } = await api.get<BoardActivityItem[]>(`/boards/${boardId}/activity`);
  return data;
}

export async function postBoardUpdate(boardId: string, body: string): Promise<BoardUpdateItem> {
  const { data } = await api.post<BoardUpdateItem>(`/boards/${boardId}/updates`, { body });
  return data;
}

export async function duplicateSprint(sprintId: string): Promise<unknown> {
  const { data } = await api.post(`/sprints/${sprintId}/duplicate`);
  return data;
}
